import { render } from "./PhotoLoader.vue?vue&type=template&id=0e086ae7"
import script from "./PhotoLoader.vue?vue&type=script&lang=js"
export * from "./PhotoLoader.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__